import { graphql, useStaticQuery } from "gatsby";
const COUNTRY = process.env.GATSBY_LOCALE_COUNTRY;

export const UseGetProductsByCondition = () => {
  const data = useStaticQuery(graphql`
    query getAllProductsByCondition {
      SubZero: shopifyCollection(handle: { eq: "sub-zero" }) {
        ...ProductFields
      }
      Cold: shopifyCollection(handle: { eq: "cold" }) {
        ...ProductFields
      }
      Mild: shopifyCollection(handle: { eq: "mild" }) {
        ...ProductFields
      }
      Hot: shopifyCollection(handle: { eq: "hot" }) {
        ...ProductFields
      }
    }
  `);
  if (COUNTRY === "US" || COUNTRY === "GB") {
    return {
      Cold: data.Cold,
      Hot: data.Hot,
      Mild: data.Mild,
      SubZero: data.SubZero,
    };
  } else if (COUNTRY === "NZ") {
    return {
      SubZero: data.SubZero,
      Cold: data.Cold,
      Hot: data.Hot,
      Mild: data.Mild,
    };
  } else if (COUNTRY === "AU") {
    return {
      Mild: data.Mild,
      SubZero: data.SubZero,
      Cold: data.Cold,
      Hot: data.Hot,
    };
  } else {
    return {
      SubZero: data.SubZero,
      Cold: data.Cold,
      Hot: data.Hot,
      Mild: data.Mild,
    };
  }
};
